/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Deletedescription1Inputs */

const id_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindakan ini tidak dapat dibatalkan. Ini akan menghapus ulasan secara permanen dari server kami.`)
};

const ms_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindakan ini tidak boleh dibatalkan. Ini akan memadam ulasan secara kekal dari pelayan kami.`)
};

const da_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne handling kan ikke fortrydes. Dette vil permanent slette anmeldelsen fra vores servere.`)
};

const de_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Aktion kann nicht rückgängig gemacht werden. Die Bewertung wird dauerhaft von unseren Servern gelöscht.`)
};

const en_us2_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone. This will permanently delete the review from our servers.`)
};

const es_es2_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta acción no se puede deshacer. Esto eliminará permanentemente la reseña de nuestros servidores.`)
};

const es_mx2_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta acción no se puede deshacer. Esto eliminará permanentemente la reseña de nuestros servidores.`)
};

const fil_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang pagkilos na ito ay hindi maaaring i-undo. Permanente nitong tatanggalin ang review mula sa aming mga server.`)
};

const fr_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette action est irréversible. Cela supprimera définitivement l'avis de nos serveurs.`)
};

const it_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa azione non può essere annullata. Eliminerà permanentemente la recensione dai nostri server.`)
};

const hu_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a művelet nem vonható vissza. Az értékelés véglegesen törlődik a szervereinkről.`)
};

const nl_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze actie kan niet ongedaan worden gemaakt. De review wordt permanent verwijderd van onze servers.`)
};

const no_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne handlingen kan ikke angres. Dette vil permanent slette omtalen fra våre servere.`)
};

const pl_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tej czynności nie można cofnąć. Recenzja zostanie trwale usunięta z naszych serwerów.`)
};

const pt_br2_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone. This will permanently delete the review from our servers.`)
};

const pt_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta ação não pode ser desfeita. Isto irá eliminar permanentemente a avaliação dos nossos servidores.`)
};

const ro_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Această acțiune nu poate fi anulată. Recenzia va fi ștearsă permanent de pe serverele noastre.`)
};

const fi_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tätä toimintoa ei voi peruuttaa. Arvostelu poistetaan pysyvästi palvelimiltamme.`)
};

const sv_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna åtgärd kan inte ångras. Recensionen kommer att tas bort permanent från våra servrar.`)
};

const vi_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hành động này không thể hoàn tác. Điều này sẽ xóa vĩnh viễn đánh giá khỏi máy chủ của chúng tôi.`)
};

const tr_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu işlem geri alınamaz. Bu, yorumu sunucularımızdan kalıcı olarak silecektir.`)
};

const cs_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuto akci nelze vrátit zpět. Recenze bude trvale smazána z našich serverů.`)
};

const bg_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Това действие не може да бъде отменено. Това ще изтрие за постоянно ревюто от нашите сървъри.`)
};

const ru_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это действие нельзя отменить. Обзор будет навсегда удалён с наших серверов.`)
};

const uk_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цю дію не можна скасувати. Відгук буде назавжди видалено з наших серверів.`)
};

const ar_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يمكن التراجع عن هذا الإجراء. سيتم حذف المراجعة بشكل دائم من خوادمنا.`)
};

const hi_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह क्रिया पूर्ववत नहीं की जा सकती।`)
};

const th_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การกระทำนี้ไม่สามารถยกเลิกได้ รีวิวนี้จะถูกลบออกจากเซิร์ฟเวอร์ของเราอย่างถาวร`)
};

const ja_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この操作は取り消せません。レビューはサーバーから完全に削除されます。`)
};

const zh_cn2_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone. This will permanently delete the review from our servers.`)
};

const zh_hant1_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone. This will permanently delete the review from our servers.`)
};

const ko_forms_review_deletedescription1 = /** @type {(inputs: Forms_Review_Deletedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be undone. This will permanently delete the review from our servers.`)
};

/**
* | output |
* | --- |
* | "This action cannot be undone. This will permanently delete the review from our servers." |
*
* @param {Forms_Review_Deletedescription1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_deletedescription1 = /** @type {((inputs?: Forms_Review_Deletedescription1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Deletedescription1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_deletedescription1(inputs)
	if (locale === "ms") return ms_forms_review_deletedescription1(inputs)
	if (locale === "da") return da_forms_review_deletedescription1(inputs)
	if (locale === "de") return de_forms_review_deletedescription1(inputs)
	if (locale === "en-US") return en_us2_forms_review_deletedescription1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_deletedescription1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_deletedescription1(inputs)
	if (locale === "fil") return fil_forms_review_deletedescription1(inputs)
	if (locale === "fr") return fr_forms_review_deletedescription1(inputs)
	if (locale === "it") return it_forms_review_deletedescription1(inputs)
	if (locale === "hu") return hu_forms_review_deletedescription1(inputs)
	if (locale === "nl") return nl_forms_review_deletedescription1(inputs)
	if (locale === "no") return no_forms_review_deletedescription1(inputs)
	if (locale === "pl") return pl_forms_review_deletedescription1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_deletedescription1(inputs)
	if (locale === "pt") return pt_forms_review_deletedescription1(inputs)
	if (locale === "ro") return ro_forms_review_deletedescription1(inputs)
	if (locale === "fi") return fi_forms_review_deletedescription1(inputs)
	if (locale === "sv") return sv_forms_review_deletedescription1(inputs)
	if (locale === "vi") return vi_forms_review_deletedescription1(inputs)
	if (locale === "tr") return tr_forms_review_deletedescription1(inputs)
	if (locale === "cs") return cs_forms_review_deletedescription1(inputs)
	if (locale === "bg") return bg_forms_review_deletedescription1(inputs)
	if (locale === "ru") return ru_forms_review_deletedescription1(inputs)
	if (locale === "uk") return uk_forms_review_deletedescription1(inputs)
	if (locale === "ar") return ar_forms_review_deletedescription1(inputs)
	if (locale === "hi") return hi_forms_review_deletedescription1(inputs)
	if (locale === "th") return th_forms_review_deletedescription1(inputs)
	if (locale === "ja") return ja_forms_review_deletedescription1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_deletedescription1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_deletedescription1(inputs)
	return ko_forms_review_deletedescription1(inputs)
});
export { forms_review_deletedescription1 as "forms.review.deleteDescription" }